import { isCourseAttachmentVideoStreamUrl } from './videoEmbed';

const AUDIO_EXTENSIONS = /\.(mp3|wav|aac|m4a|ogg)(\?.*)?$/i;

export function normalizeLessonAudioUrl(raw) {
  if (raw == null) return '';
  const t = String(raw).trim();
  if (!t) return '';
  if (/^https?:\/\//i.test(t)) return t;
  if (t.startsWith('//')) return `https:${t}`;
  return `https://${t}`;
}

export function isCourseAttachmentMediaStreamUrl(urlString) {
  return isCourseAttachmentVideoStreamUrl(urlString);
}

export function looksLikeAudioUrl(urlString) {
  if (!urlString || typeof urlString !== 'string') return false;
  const t = urlString.trim();
  if (!t) return false;
  if (AUDIO_EXTENSIONS.test(t)) return true;
  try {
    const path = new URL(t.startsWith('http') ? t : `https://${t}`).pathname.toLowerCase();
    return AUDIO_EXTENSIONS.test(path);
  } catch {
    return AUDIO_EXTENSIONS.test(t);
  }
}

export function canPlayAudioUrl(url) {
  if (!url || typeof url !== 'string') return false;
  if (isCourseAttachmentMediaStreamUrl(url)) return true;
  return looksLikeAudioUrl(url);
}

export function lessonAudioAttachmentFileIdFromUrl(url) {
  if (!url) return null;
  const m = String(url).match(/\/attachments\/([a-fA-F0-9]{24})/);
  return m ? m[1] : null;
}

export function formatAudioDuration(seconds) {
  const n = Number(seconds);
  if (!Number.isFinite(n) || n < 0) return '';
  const total = Math.floor(n);
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = total % 60;
  const pad = v => String(v).padStart(2, '0');
  if (h > 0) return `${h}:${pad(m)}:${pad(s)}`;
  return `${m}:${pad(s)}`;
}

export function serializeLessonAudioForBaseline(audio) {
  if (!audio || !audio.url) return null;
  return {
    url: audio.url ?? '',
    filename: audio.filename ?? '',
    size: audio.size != null ? Number(audio.size) : null,
    duration: audio.duration != null ? Number(audio.duration) : null
  };
}

export function buildLessonAudioPayload(audio) {
  const url = audio?.url != null ? String(audio.url).trim() : '';
  if (!url) return null;
  const out = { url };
  if (audio.filename != null && String(audio.filename).trim()) {
    out.filename = String(audio.filename).trim();
  }
  if (audio.size != null && audio.size !== '') {
    const size = Number(audio.size);
    if (Number.isFinite(size) && size >= 0) out.size = size;
  }
  if (audio.duration != null && audio.duration !== '') {
    const duration = Number(audio.duration);
    if (Number.isFinite(duration) && duration >= 0) out.duration = duration;
  }
  return out;
}
